import styled from '@emotion/styled';
import { CDSColor, CDSFont } from 'design-system-webview';
import { ThemeProvider } from 'styled-components';
import { BrandSitesV2GlobalStyle, BrandSitesV2Theme } from '../components/BrandSitesV2/common/GlobalStyle';
import Header from '../components/BrandSitesV2/common/Header';

const NotFoundPage = () => {
  return (
    <>
      <BrandSitesV2GlobalStyle />
      <ThemeProvider theme={BrandSitesV2Theme}>
        <Header />
        <MainContainer>
          <Container>
            <SvgDesktopContainer>
              <SvgDesktop />
            </SvgDesktopContainer>
            <SvgTabletContainer>
              <SvgTablet />
            </SvgTabletContainer>
            <SvgMobileContainer>
              <SvgMobile />
            </SvgMobileContainer>
            <Title>문제가 발생했어요.</Title>
            <SubTitle>페이지가 존재하지 않거나 변경되었습니다.</SubTitle>
          </Container>
        </MainContainer>
      </ThemeProvider>
    </>
  );
};

export default NotFoundPage;

const MainContainer = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100vh;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const SvgDesktopContainer = styled.div`
  display: block;

  @media (max-width: 1279px) {
    display: none;
  }
`;

const SvgTabletContainer = styled.div`
  display: none;

  @media (max-width: 1279px) {
    display: block;
  }

  @media (max-width: 833px) {
    display: none;
  }
`;

const SvgMobileContainer = styled.div`
  display: none;

  @media (max-width: 833px) {
    display: block;
  }
`;

const Title = styled.span`
  ${CDSFont('Heading/HD4_B')}
  margin-top: 32px;

  @media (max-width: 1279px) {
    ${CDSFont('Heading/HD5_B')}
  }

  @media (max-width: 833px) {
    ${CDSFont('Title/T1_B')}
    margin-top: 24px;
  }
`;

const SubTitle = styled.span`
  ${CDSFont('Title/T1_R')}
  color: ${CDSColor('Text/Support')};

  @media (max-width: 1279px) {
    ${CDSFont('Title/T2_R')}
  }

  @media (max-width: 833px) {
    ${CDSFont('Body/B1_R_A11Y')}
  }

  margin-top: 4px;
`;

const SvgDesktop = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="124" height="65" viewBox="0 0 124 65" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M67.4922 11.9815C73.3594 4.96714 82.1689 0.500031 92.023 0.500031C109.68 0.500031 123.993 14.827 124 32.5C124 50.1731 109.686 64.5 92.0298 64.5C74.911 64.5 60.9365 51.0301 60.1008 34.1011L48.9451 37.7522L60.3268 53.4677L45.1809 64.4589L33.7375 48.6577L22.2942 64.4589L7.14825 53.4677L18.506 37.7865L0 31.7321L5.81245 13.9356L24.3732 20.0106V0.500031H43.0779V19.9729L67.4922 11.9815ZM87.8336 14.9516H98.1669L97.1336 39.7258H88.8669L87.8336 14.9516ZM88.8675 43.8549H97.1341V50.0484H88.8675V43.8549Z"
      fill="#00BED6"
    />
  </svg>
);

const SvgTablet = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="96" height="51" viewBox="0 0 96 51" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.252 9.46996C56.7944 3.98999 63.6146 0.500061 71.2436 0.500061C84.9132 0.500061 95.9947 11.693 96 25.5001C96 39.3071 84.9185 50.5001 71.2489 50.5001C57.9956 50.5001 47.1766 39.9767 46.5296 26.7509L37.893 29.6033L46.7046 41.881L34.9788 50.4679L26.1194 38.1233L17.26 50.4679L5.53413 41.881L14.3272 29.6301L0 24.9001L4.49996 10.9966L18.8696 15.7427V0.500061H33.3506V15.7133L52.252 9.46996ZM68.5 11.5001H76.5L75.5 31.5001H69.5L68.5 11.5001ZM69.5 34.5001H75.5V39.5001H69.5V34.5001Z"
      fill="#00BED6"
    />
  </svg>
);

const SvgMobile = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="42" viewBox="0 0 80 42" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.5434 8.05578C47.3287 3.56221 53.0122 0.70047 59.3697 0.70047C70.761 0.70047 79.9956 9.87869 80 21.2005C80 32.5223 70.7654 41.7005 59.3741 41.7005C48.3297 41.7005 39.3139 33.0713 38.7747 22.2261L31.5775 24.5652L38.9205 34.6329L29.149 41.6741L21.7662 31.5515L14.3833 41.6741L4.61177 34.6329L11.9393 24.5871L0 20.7085L3.74997 9.30766L15.7247 13.1995V0.70047H27.7922V13.1753L43.5434 8.05578ZM57 9.70047H64L63 25.7005H58L57 9.70047ZM58 28.7005H63V32.7005H58V28.7005Z"
      fill="#00BED6"
    />
  </svg>
);
